/* V314 · 03.10.2026 — אישורי זהר 03.10 (ערב):
   1. "ליווי עד הצלחה — בלי הגבלת זמן" (DECISION-0310-SUCCESS-ACCOMPANIMENT-OFFER): כותרת השער + פופאפ פעם אחת.
   2. "שמור האבחון שלי - אני מבקש לדבר עם נציג החברה" + "נאפשר ללקוח לקבוע טווח שעות ויום" (DECISION-0310-SAVE-DIAG-TALK-BUTTON).
      ימים: א׳–ה׳ 9–12 · 12–15 · 15–18 · 18–20 · ו׳ 9–13 · שבת לא מוצעת.
   3. שיתוף ההמלצה לבן/בת הזוג (וואטסאפ).
   4. זיכרון האבחון בדפדפן (sw_diag_saved) — מוצג בביקור חוזר ע"י sw-diag-memory.js; ונשמר במאפייני העגלה (_diag_*).
   הליד נשלח בדיוק כמו קודם (sw-gate-go → swSendLead). הכוונה עוברת בשדות notes + preferred_channel שהמוח כבר מקבל
   ונכתבים להערת הליד ב-CRM. callback {date, window} מצורף לשימוש עתידי של המוח. */
/* V316 · 03.10.2026 — אישור זהר: "מאשר 7 ימים" + "מאשר הכל" (PLAN-V316-ACCOMPANIMENT-7-DAYS):
   ההטבה (ליווי עד הצלחה) חלה על רכישה באתר עד סוף היום ה-7 מהשארת הפרטים (שעון ישראל). הליווי עצמו — בלי הגבלת זמן.
   offer_until (YYYY-MM-DD) נשמר ב-sw_diag_saved ובמאפיין העגלה _diag_offer_until. הרשמה חוזרת בתוך התוקף לא מאריכה אותו. */
(function () {
  'use strict';
  var $ = function (id) { return document.getElementById(id); };
  var DAYS = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
  var WIN_WEEK = [[9, 12], [12, 15], [15, 18], [18, 20]];
  var WIN_FRI = [[9, 13]];
  var LS_SAVED = 'sw_diag_saved', LS_POP = 'sw_acc_pop_ts';

  function ev(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: name }; for (var k in (params || {})) o[k] = params[k];
      window.dataLayer.push(o);
      if (typeof gtag === 'function') gtag('event', name, params || {});
      if (typeof clarity === 'function') clarity('event', name);
    } catch (e) {}
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function ddmm(d) { return pad(d.getDate()) + '.' + pad(d.getMonth() + 1); }
  function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function isSurg() { var r = $('sw-diag-result'); return !!(r && r.classList.contains('sw-surg')); }

  /* ── V316 · מועד מימוש: 7 ימים, לפי שעון ישראל ── */
  function ilYmd(ts) {
    try { var s = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Jerusalem', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(ts)); if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s; } catch (e) {}
    return iso(new Date(ts));
  }
  function addDaysYmd(ymd, n) { var p = ymd.split('-'); var d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2] + n)); return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function ymdDM(ymd) { var p = String(ymd).split('-'); return p[2] + '.' + p[1]; }
  function ymdFull(ymd) { var p = String(ymd).split('-'); return p[2] + '.' + p[1] + '.' + p[0]; }
  function activeUntil() { /* תוקף קיים ופעיל — לא מאריכים */
    try { var d = JSON.parse(localStorage.getItem(LS_SAVED) || 'null'); if (d && d.offer_until && d.offer_until >= ilYmd(Date.now())) return d.offer_until; } catch (e) {}
    return '';
  }
  function offerUntil() { return activeUntil() || addDaysYmd(ilYmd(Date.now()), 7); }
  function fillUntil() {
    var u = ymdDM(offerUntil()), had = !!activeUntil(), els = document.querySelectorAll('.sw-acc-until'), rel = document.querySelectorAll('.sw-acc-rel'), i;
    for (i = 0; i < els.length; i++) els[i].textContent = u;
    for (i = 0; i < rel.length; i++) rel[i].style.display = had ? 'none' : ''; /* תוקף קיים — לא "7 ימים מהיום" */
  }

  /* ── ימים וחלונות ── */
  function windowsFor(d) { var w = d.getDay(); return w === 6 ? [] : (w === 5 ? WIN_FRI : WIN_WEEK); }
  function openWindows(d, now) {
    var sameDay = iso(d) === iso(now);
    return windowsFor(d).filter(function (w) {
      if (!sameDay) return true;
      return (w[1] * 60) - (now.getHours() * 60 + now.getMinutes()) >= 45; /* חלון שנגמר בעוד פחות מ-45 דק' — לא מוצע */
    });
  }
  function buildDays() {
    var sel = $('sw-slot-day'); if (!sel) return;
    var now = new Date(); sel.innerHTML = '';
    for (var i = 0, added = 0; i < 10 && added < 6; i++) {
      var d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i);
      if (!openWindows(d, now).length) continue;
      var lbl = (i === 0 ? 'היום' : (i === 1 ? 'מחר' : 'יום ' + DAYS[d.getDay()])) + ' · ' + (i <= 1 ? 'יום ' + DAYS[d.getDay()] + ' ' : '') + ddmm(d);
      var o = document.createElement('option'); o.value = iso(d); o.textContent = lbl; o.setAttribute('data-label', lbl); o.setAttribute('data-he', i === 0 ? 'היום' : (i === 1 ? 'מחר' : 'ביום ' + DAYS[d.getDay()])); o.setAttribute('data-dm', ddmm(d));
      sel.appendChild(o); added++;
    }
    buildWins();
  }
  function buildWins() {
    var ds = $('sw-slot-day'), ws = $('sw-slot-win'); if (!ds || !ws) return;
    var p = (ds.value || '').split('-'); if (p.length !== 3) { ws.innerHTML = ''; return; }
    var d = new Date(+p[0], +p[1] - 1, +p[2]);
    ws.innerHTML = '';
    openWindows(d, new Date()).forEach(function (w) {
      var o = document.createElement('option'); o.value = pad(w[0]) + ':00-' + pad(w[1]) + ':00';
      o.textContent = 'בין ' + w[0] + ':00 ל-' + w[1] + ':00'; ws.appendChild(o);
    });
  }

  /* ── כוונה → payload (notes / preferred_channel שהמוח כבר שומר) ── */
  var talkMode = false, pendingIntent = null;
  function kgText() { var k = $('sw-res-kg'); return k ? k.textContent.trim() : ''; }
  function setIntent(intent) {
    var p = window._swLastPayload; if (!p) return;
    if (intent.type === 'talk') {
      p.preferred_channel = 'שיחה עם נציג';
      p.notes = 'מבקש שיחה עם נציג החברה · ' + intent.label + ' · ' + intent.win + ' · (V314)' + (window.swNoteTail && window.swNoteTail() ? ' · ' + window.swNoteTail() : ''); /* V317 */
      p.callback = { date: intent.date, window: intent.win };
    } else {
      p.preferred_channel = 'ליווי עד הצלחה';
      p.notes = 'ביקש ליווי עד הצלחה · ההטבה בתוקף לרכישה באתר עד ' + ymdFull(offerUntil()) + ', של ' + (kgText() || 'המשקל המומלץ') + ' ומעלה · הליווי עצמו ללא הגבלת זמן · (V316)' + (window.swNoteTail && window.swNoteTail() ? ' · ' + window.swNoteTail() : ''); /* V317 */
      try { delete p.callback; } catch (e) {}
    }
    intent.until = offerUntil();
    intent.email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((($('sw-gate-email') || {}).value || '').trim());
    pendingIntent = intent;
  }
  function afterSubmit() {
    /* ה-handler המקורי מסתיר את השער רק כשהשליחה עברה ולידציה */
    setTimeout(function () {
      var g = $('sw-diag-gate'); if (!g || g.style.display !== 'none' || !pendingIntent) return;
      var done = $('sw-res-intent-done'); var it = pendingIntent; pendingIntent = null;
      if (done) {
        done.textContent = it.type === 'talk'
          ? '✓ האבחון שלכם נשמר. נציג יתקשר אליכם ' + it.he + ' (' + it.dm + '), ' + it.winHe + '.'
          : '✓ נרשמתם לליווי עד הצלחה, וההתחייבות נרשמה על שמכם. היא חלה ברכישה באתר עד ' + ymdDM(it.until) + ' של ' + (kgText() ? 'מנורה של ' + kgText() : 'המנורה שהומלצה לכם') + ' (או גדולה ממנה).' + (it.email ? ' שלחנו לכם אותה גם במייל.' : '');
        done.style.display = 'block';
      }
      saveDiag({ contact_left: true, offer: it.type === 'talk' ? 'שיחה עם נציג' : 'ליווי עד הצלחה', offer_until: it.until });
      ev(it.type === 'talk' ? 'diag_talk_request' : 'acc_offer_accept', it.type === 'talk' ? { callback_date: it.date, callback_window: it.win, offer_until: it.until } : { offer_until: it.until });
    }, 0);
  }

  /* כפתור הליווי (sw-gate-go) — capture: הכוונה נכנסת ל-payload לפני ה-handler המקורי */
  document.addEventListener('click', function (e) {
    var go = e.target && e.target.closest && e.target.closest('#sw-gate-go');
    if (!go || isSurg()) return;
    if (!talkMode) setIntent({ type: 'accompaniment' });
    afterSubmit();
  }, true);

  function bindGate() {
    var t = $('sw-gate-talk'), slot = $('sw-gate-slot'), tg = $('sw-gate-talk-go'), ds = $('sw-slot-day');
    if (!t || !slot || !tg) return;
    t.addEventListener('click', function () {
      buildDays(); slot.style.display = 'block'; ev('diag_talk_open');
      var n = $('sw-gate-name'); if (n && !n.value.trim()) { try { n.focus({ preventScroll: true }); } catch (e) { n.focus(); } }
      slot.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    if (ds) ds.addEventListener('change', buildWins);
    tg.addEventListener('click', function () {
      var msg = $('sw-gate-msg');
      var ph = (($('sw-gate-phone') || {}).value || '').replace(/[^0-9+]/g, '');
      if (!/^0\d{8,9}$|^\+?972\d{8,9}$/.test(ph)) { if (msg) msg.textContent = 'כדי שנתקשר — נא להשאיר מספר טלפון (למשל 0501234567)'; var pf = $('sw-gate-phone'); if (pf) pf.focus(); return; }
      var dOpt = ds && ds.options[ds.selectedIndex], ws = $('sw-slot-win'), wOpt = ws && ws.options[ws.selectedIndex];
      if (!dOpt || !wOpt) { if (msg) msg.textContent = 'נא לבחור יום ושעות'; return; }
      setIntent({ type: 'talk', date: dOpt.value, label: dOpt.getAttribute('data-label'), he: dOpt.getAttribute('data-he'), dm: dOpt.getAttribute('data-dm'), win: wOpt.value, winHe: wOpt.textContent });
      talkMode = true;
      var go = $('sw-gate-go'); if (go) go.click(); /* אותה ולידציה ואותה שליחה כמו כפתור הליווי */
      talkMode = false;
    });
  }

  /* ── שיתוף לבן/בת הזוג + זיכרון האבחון ── */
  function saveDiag(extra) {
    try {
      var buy = $('sw-res-buy'), pers = $('sw-res-personal'), lab = $('sw-res-label'), wa = $('sw-res-wa');
      var prev = JSON.parse(localStorage.getItem(LS_SAVED) || 'null') || {};
      var o = {
        kg: kgText(), label: lab ? lab.textContent.trim() : '', personal: pers ? pers.textContent.trim() : '',
        url: buy ? buy.getAttribute('href') : '', wa: wa ? wa.getAttribute('href') : '',
        ts: prev.ts && prev.kg === kgText() ? prev.ts : Date.now(), page: location.pathname
      };
      for (var k in (extra || {})) o[k] = extra[k];
      if (prev.contact_left && !o.contact_left) o.contact_left = true;
      if (prev.offer && !o.offer) o.offer = prev.offer;
      if (prev.offer_until && prev.offer_until >= ilYmd(Date.now())) o.offer_until = prev.offer_until; /* V316 — לא מאריכים תוקף פעיל */
      else if (prev.offer_until && !o.offer_until) o.offer_until = prev.offer_until;
      if (!o.kg || o.kg === '—') return;
      localStorage.setItem(LS_SAVED, JSON.stringify(o));
      if (window.swDiagCartSync) window.swDiagCartSync(true);
    } catch (e) {}
  }
  function onResult() {
    if (isSurg()) return;
    saveDiag();
    fillUntil();
    try {
      var s = $('sw-res-share'), buy = $('sw-res-buy'), pers = $('sw-res-personal');
      if (s) {
        var u = buy ? buy.href : location.origin;
        var txt = 'עשיתי אבחון התאמה בנפלאות המלח. הומלצה לנו ' + (kgText() ? 'מנורה של ' + kgText() : 'מנורת מלח') +
          (pers && pers.textContent ? ' (' + pers.textContent.trim() + ')' : '') + '. כדאי לך להסתכל: ' + u;
        s.href = 'https://wa.me/?text=' + encodeURIComponent(txt);
      }
    } catch (e) {}
    schedulePopup();
  }

  /* ── פופאפ "ליווי עד הצלחה" — פעם אחת ב-7 ימים, רק כשהשער מוצג ואין פרטים ── */
  var popTimer = null;
  function schedulePopup() {
    return; /* V318 · 04.10.2026 — הפופאפ בוטל (אישור זהר "כן", DEEP-CHECK-0410): היום הוצג 5 פעמים ונסגר 5 פעמים. הקוד נשאר להחזרה. */
    if (popTimer) clearTimeout(popTimer);
    popTimer = setTimeout(function () {
      var g = $('sw-diag-gate');
      if (!g || g.style.display === 'none' || window._swContact || isSurg()) return;
      try { var t = +localStorage.getItem(LS_POP) || 0; if (Date.now() - t < 7 * 864e5) return; localStorage.setItem(LS_POP, String(Date.now())); } catch (e) {}
      showPopup();
    }, 6000);
  }
  function showPopup() {
    if ($('sw-acc-pop')) return;
    var css = document.createElement('style');
    css.textContent = '#sw-acc-pop{position:fixed;inset:0;z-index:2147483000;background:rgba(18,46,56,.55);display:flex;align-items:flex-end;justify-content:center;direction:rtl;font-family:Heebo,HeeboFB,Arial,sans-serif}'
      + '@media (min-width:640px){#sw-acc-pop{align-items:center}}'
      + '#sw-acc-pop .b{background:#fff;color:#122E38;width:100%;max-width:460px;border-radius:18px 18px 0 0;padding:1.3rem 1.2rem calc(1.1rem + env(safe-area-inset-bottom));box-shadow:0 -10px 40px rgba(0,0,0,.25);text-align:right;position:relative}'
      + '@media (min-width:640px){#sw-acc-pop .b{border-radius:18px}}'
      + '#sw-acc-pop h3{margin:0 0 .45rem;padding-left:2.4rem;font-size:1.2rem;font-weight:900;color:#122E38}'
      + '#sw-acc-pop p{margin:0 0 .9rem;font-size:.95rem;line-height:1.65;color:#33414a}'
      + '#sw-acc-pop button{display:block;width:100%;border-radius:11px;padding:.85rem;font-weight:900;font-size:1rem;cursor:pointer;font-family:inherit;margin-top:.5rem}'
      + '#sw-acc-pop .a1{background:linear-gradient(90deg,#C4511E,#B84A1C);color:#fff;border:0}'
      + '#sw-acc-pop .a2{background:#fff;color:#122E38;border:2px solid #122E38}'
      + '#sw-acc-pop .x{position:absolute;top:.5rem;left:.5rem;width:40px;height:40px;margin:0;padding:0;border:0;background:transparent;color:#5a6a70;font-size:1.4rem}'
      + '#sw-acc-pop .later{background:transparent;border:0;color:#5a6a70;font-weight:600;font-size:.88rem;text-decoration:underline}'
      + '@media (prefers-reduced-motion:no-preference){#sw-acc-pop .b{animation:swAccUp .25s ease}}@keyframes swAccUp{from{transform:translateY(30px);opacity:0}to{transform:none;opacity:1}}';
    document.head.appendChild(css);
    var w = document.createElement('div');
    w.id = 'sw-acc-pop'; w.setAttribute('role', 'dialog'); w.setAttribute('aria-modal', 'true'); w.setAttribute('aria-labelledby', 'sw-acc-h');
    w.innerHTML = '<div class="b"><button type="button" class="x" aria-label="סגירה">✕</button>'
      + '<h3 id="sw-acc-h">רוצים ליווי עד הצלחה — בלי הגבלת זמן? 🤝</h3>'
      + '<p>השאירו פרטים. אם תרכשו באתר עד <b class="sw-acc-until">' + ymdDM(offerUntil()) + '</b><span class="sw-acc-rel"> (7 ימים מהיום)</span> את המנורה שהומלצה לכם (או גדולה ממנה), תקבלו התחייבות לליווי אישי עד הצלחת הטיפול — לא 30 יום, אלא עד שזה עובד אצלכם. תמיכה מלאה, בלי חיוב נוסף.</p>'
      + '<button type="button" class="a1">אני רוצה ליווי עד הצלחה ←</button>'
      + '<button type="button" class="a2">📞 שמור את האבחון שלי — אני מבקש לדבר עם נציג החברה</button>'
      + '<button type="button" class="later">אולי אחר כך</button></div>';
    document.body.appendChild(w);
    fillUntil();
    ev('acc_popup_shown');
    function close(how) { try { w.remove(); } catch (e) { w.parentNode && w.parentNode.removeChild(w); } document.removeEventListener('keydown', esc); ev('acc_popup_close', { how: how }); }
    function esc(e) { if (e.key === 'Escape') close('esc'); }
    document.addEventListener('keydown', esc);
    w.addEventListener('click', function (e) { if (e.target === w) close('backdrop'); });
    w.querySelector('.x').addEventListener('click', function () { close('x'); });
    w.querySelector('.later').addEventListener('click', function () { close('later'); });
    w.querySelector('.a1').addEventListener('click', function () {
      close('accept'); var g = $('sw-diag-gate'); if (g) g.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var n = $('sw-gate-name'); if (n) setTimeout(function () { try { n.focus({ preventScroll: true }); } catch (e) { n.focus(); } }, 350);
    });
    w.querySelector('.a2').addEventListener('click', function () { close('talk'); var t = $('sw-gate-talk'); if (t) t.click(); });
    setTimeout(function () { var a = w.querySelector('.a1'); if (a) try { a.focus({ preventScroll: true }); } catch (e) {} }, 50);
  }

  /* ── חיבור לתוצאה: עוטפים את swShowResult (הקובץ הראשי נטען לפנינו, defer) ── */
  function hook() {
    if (typeof window.swShowResult === 'function' && !window.swShowResult._v314) {
      var orig = window.swShowResult;
      window.swShowResult = function () { var r = orig.apply(this, arguments); try { onResult(); } catch (e) {} return r; };
      window.swShowResult._v314 = true;
    }
    var res = $('sw-diag-result');
    if (res && res.style.display === 'block') { try { onResult(); } catch (e) {} } /* תוצאה שכבר הוצגה לפני שנטענו */
  }
  function init() { bindGate(); hook(); fillUntil(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
